import React from 'react'
import PropTypes from 'prop-types'
import Icon from 'components/common/Icon/Icon'

const LogoPrint = ({
  asset = 'logo',
  alt = 'BigO Tire',
  width = 228,
  height = 27,
  ...props
}) =>
  <Icon data-printonly { ...props } asset={ asset } alt={ alt } width={ width } height={ height } />

export default LogoPrint

LogoPrint.propTypes = {
  alt: PropTypes.string,
  asset: PropTypes.string,
  height: PropTypes.number,
  width: PropTypes.number
}
